<template>
  <card-block>
    <spinner-block v-model="dataProgress">
      <div v-if="data">
        <card-header>
          <template v-if="id">
            <router-link :to="{name: 'release_note.detail', params: {id: id}}">Примечание к выпуску</router-link><!-- -->:
            редактирование

          </template>
          <template v-else>
            <router-link :to="{name: 'release_note.list'}">Примечание к выпуску</router-link><!-- -->:
            создание
          </template>


        </card-header>
        <card-body>
          <gui-checkbox v-model="data.is_active" :error="dataError.is_active" label="Активный"/>
          <gui-application-select v-model="data.application_id" :error="dataError.application_id" label="Тип приложения" @change="()=>data.question_section_id=''"/>
          <gui-input v-model="data.version" :error="dataError.version" label="Версия" placeholder="1.2"/>
          <gui-question-element-select  clearable v-model="data.question_section_id" :error="dataError.question_section_id" label="ID из раздела FAQ" :application_type_id="data.application_id" :key="`picker-for-${data.application_id}`" :excludeQuestionTypeId="[1]"/>
          <gui-textarea v-model="data.note" :error="dataError.note" label="Примечание"/>

          <div class="mt-5">
            <button-save v-if="!data.id" @click="add()"/>
            <button-save v-else @click="save"/>
            <button-back/>
          </div>
        </card-body>
      </div>
    </spinner-block>
  </card-block>
</template>

<script>


import GuiApplicationSelect from "@/components/Widget/GuiApplicationSelect.vue";
import GuiQuestionElementSelect from "@/components/Widget/GuiQuestionElementSelect.vue";

export default {
  components: {GuiQuestionElementSelect, GuiApplicationSelect},
  data() {
    return {
      data: null,
      dataDefault: {
        is_active: '',
        application_id: 1,
        question_section_id: '',
        version: '',
        note: '',
      },
      dataError: {
        is_active: '',
        application_id: '',
        question_section_id: '',
        version: '',
        note: '',
      },
      dataProgress: false,
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.init()
  },
  methods: {

    init() {
      if (this.id) {
        this.data = null
        this.loadData()
      } else {
        this.data = _.clone(this.dataDefault)
      }
    },
    loadData() {
      axiosGetValue('/api/admin/release-note/get', {id: this.id}, e => this.data = e, e => this.dataProgress = e)
    },

    save() {
      axiosFast({
        url: route('/api/admin/release-note/update'),
        data: {data: this.data, id: this.data.id},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: () => {
          toastSuccess('Данные сохранены');
          this.$router.push({name: 'release_note.detail', params: {id: this.data.id}})
        },
      })
    },
    add() {
      axiosFast({
        url: route('/api/admin/release-note/create'),
        data: {data: this.data},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: (data) => {
          toastSuccess('Данные добавлены');
          this.$router.push({name: 'release_note.detail', params: {id: data.id}})
        },
      })
    },
  },
}
</script>
